export const TOPIC = {
  TRASHED_SUCCESS_MESSAGE: 'You’ve trashed the topic.',
  RESTORED_SUCCESS_MESSAGE: 'You’ve restored the topic.',
  ACTION: 'Trash the topic'
} as const

export const REPLY = {
  TRASHED_SUCCESS_MESSAGE: 'You’ve trashed the reply.',
  RESTORED_SUCCESS_MESSAGE: 'You’ve restored the reply.',
  ACTION: 'Trash the reply'
} as const
